// client/src/routes/app/expenses/suppliers.tsx — SCR-EXP-004 · EXP-005 (04 §8.7).
//
// „Furnizori & facturi" at the one URL 04 gives it. Both registries page and filter through this
// route's search params (§9.2.3), which is why the schema prefixes the invoice half's names.
//
// `Expenses.Read` opens it; every write control inside requires `Expenses.Write` (D-725).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { SupplierRegistry } from '@/features/expenses/SupplierRegistry';
import { supplierSearchSchema, type SupplierSearch } from '@/features/expenses/search';

export const Route = createFileRoute('/app/expenses/suppliers')({
  validateSearch: supplierSearchSchema,
  component: SuppliersScreen,
});

function SuppliersScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Expenses.Read">
      <SupplierRegistry
        search={search}
        onSearchChange={(next: (previous: SupplierSearch) => SupplierSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
